/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:06 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    {
      if: { focus: true },
      tokens: {
        backgroundColor: '#efefef',
        color: '#000000',
        iconColor: '#000000',
        iconSize: 26
      }
    },
    {
      if: { pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        color: '#5b2bc2',
        iconColor: '#5b2bc2',
        iconSize: 22
      }
    },
    { if: { hover: true }, tokens: { iconSize: 26 } }
  ],
  tokens: {
    activeColor: '#7a3dfc',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    borderRadius: 4,
    color: '#000000',
    fontName: 'StagSans',
    fontWeight: '600',
    iconColor: '#000000',
    iconSize: 24,
    lineHeight: 1.33333333333,
    paddingBottom: 4,
    paddingTop: 4
  }
}
export default theme
